import React, { useEffect, useState } from "react";
import { Box, Button, Typography, LinearProgress } from "@mui/material";
import HearingTestUI from "./HearingTestUI";
import BOYIMAGE from "../../assets/images/boy_image.svg";
import { ArrowBackIosNew } from "@mui/icons-material";
import PatientHearingDetails from "./PatientHearingDetails";
import IntroStepUI from "./IntroPhaseUI";
import PhaseOneUI from "./PhaseOneUi";
import PhaseTwoUI from "./PhaseTwoUI";
import { useNavigate, useParams } from "react-router-dom";
import PhaseThreeUI from "./PhaseThreeUI";
import PhaseFourUI from "./PhaseFourUI";
import PhaseFiveUI from "./PhaseFiveUI";

const HearingTestMainUi = ({
  comfortableLoudness,
  setComfortableLoudness,
  selectedWave,
  setSelectedWave,
  selectedEar,
  canvasRef,
  startWaveAnimation,
  isMobile,
  setSelectedEar,
  frequency,
  setFrequency,
  setIsPlaying,
  isPlaying,
  phase,
  onSubmit,
  selectedTone,
  tinnitusLoudness,
  setTinnitusLoudness,
  isNoisePlaying,
  selectedNoise,
  setSelectedNoise,
  handlePlayTone,
  handleSelectTone,
  handleLoudnessTest,
  handleFrequencyTest,
  handleTinnitusLoudnessTest,
  handlePlayPauseNoise,
  increaseLoudness,
  decreaseLoudness,
  increaseTinnitusLoudness,
  decreaseTinnitusLoudness,
  increaseFreq,
  decreaseFreq,
  handleFrequencyChange,
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();
  const params = useParams()
  // Handle navigation
  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => {
    if (activeStep === 0) {
      navigate(`/Patient-Details/${params.id}`);
    } else {
      setActiveStep((prev) => prev - 1);
    }
  };
  const steps = [
    {
      label: "Introduction",
      component: <IntroStepUI handleNext={handleNext} />,
    },
    {
      label: "Comfort Volume",
      component: (
        <PhaseOneUI
          handleNext={handleNext}
          comfortableLoudness={comfortableLoudness}
          setComfortableLoudness={setComfortableLoudness}
          increaseLoudness={increaseLoudness}
          decreaseLoudness={decreaseLoudness}
          handleLoudnessTest={handleLoudnessTest}
          isPlaying={isPlaying}
        />
      ),
    },
    {
      label: "Select Ears",
      component: (
        <PhaseTwoUI
          selectedEar={selectedEar}
          setSelectedEar={setSelectedEar}
          handleNext={handleNext}
        />
      ),
    },
    { label: 'Frequency test', component: <PhaseThreeUI handleNext={handleNext} frequency={frequency} setFrequency={setFrequency} handleFrequencyChange={handleFrequencyChange} handleFrequencyTest={handleFrequencyTest} increaseFreq={increaseFreq} decreaseFreq={decreaseFreq} selectedWave={selectedWave}
    setSelectedWave={setSelectedWave}  canvasRef={canvasRef} startWaveAnimation={startWaveAnimation} isMobile={isMobile}/> },
    {
      label: "Tinnitus loudness",
      component: (
        <PhaseFourUI
          handleNext={handleNext}
          tinnitusLoudness={tinnitusLoudness}
          setTinnitusLoudness={setTinnitusLoudness}
          increaseTinnitusLoudness={increaseTinnitusLoudness}
          decreaseTinnitusLoudness={decreaseTinnitusLoudness}

          handleTinnitusLoudnessTest={handleTinnitusLoudnessTest}
          isPlaying={isPlaying}
        />
      ),
    },
    {
      label: "noise check",
      component: (
        <PhaseFiveUI
          onSubmit={onSubmit}
          handlePlayPauseNoise={handlePlayPauseNoise} isNoisePlaying={isNoisePlaying}  setSelectedNoise={setSelectedNoise} selectedNoise={selectedNoise}
        />
      ),
    },
  ];

  return (
    <Box sx={{ backgroundColor: "white", p: "20px", height: "90vh" }}>
      {/* Header Section */}
      <Box
        mb={1}
        sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <Button onClick={handleBack}>
            <ArrowBackIosNew fontSize="small" sx={{ color: "#424242" }} />
            <Typography
              ml={2}
              className="AxiformaRegular"
              sx={{ fontSize: "24px", alignItems: "center", color: "#424242" }}
            >
              Back
            </Typography>
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Typography
            className="AxiformaMedium"
            variant="h6"
            ml={2}
            sx={{
              fontSize: "24px",
              alignItems: "center",
              letterSpacing: "0.8em",
              color: "#424242",
            }}
          >
            TINNITUS FREQUENCY TEST
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",

          height: "100%",
          backgroundColor: "#F9F9F9",
          position: "relative",
        }}
      >
        <LinearProgress
          variant="determinate"
          value={(activeStep / (steps.length - 1)) * 100}
          sx={{
            width: "72%",
            mb: 5,
            mt: 5,
            backgroundColor: "#DEDEDE",
            height: "8px",
            borderRadius: "4px",
          }}
        />

        {/* Dynamic Step Content */}
       
          {steps[activeStep].component}
      

        <img
          src={BOYIMAGE}
          alt="boy illustration"
          style={{ position: "absolute", bottom: 0, left: 0, width: "17vw" }}
        />
      </Box>
    </Box>
  );
};

export default HearingTestMainUi;
